<div *ngIf="showUpdateReady" class="bg-primary sticky top-0 px-4 py-2" style="z-index: 999">
  <div class="flex justify-content-center align-items-center relative">
    <p class="inter-300 mx-auto">
      A new version of this website is available
      <span (click)="location.reload();" class="inter-600 cursor-pointer">UPDATE NOW</span>
    </p>
    <i (click)="showUpdateReady = false;" class="pi pi-times cursor-pointer ml-3"></i>
  </div>
</div>
<ng-container [ngSwitch]="isNltrPresent">
  <p *ngSwitchCase="true" class="m-0 p-4">Please wait while we load the brochure...</p>
  <router-outlet *ngSwitchDefault></router-outlet>
</ng-container>
